import { Box, Typography } from "@material-ui/core";
import SkillScoreChart from "Components/skills/SkillScoreChart";
import { first, orderBy } from "lodash";
import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { checkinSRSDetailsState } from "Recoil/Targets/atom";
import { checkArrayLength } from "src/utils";
import { generateUserSkills } from "src/utils/skillScore";

const ScoreChart = ({
  totalRaters,
  taggedSkillToTarget,
  setTaggedSkillToTarget,
  selectedSkillName,
  setSelectedSkillName,
  label,
  skillRatee,
}) => {
  const [nodataSkill, setNoDataSkill] = useState([]);
  const { skills } = useRecoilValue(checkinSRSDetailsState);
  useEffect(() => {
    skillRatee?.userid && setSelectedSkillName("");
  }, [skillRatee?.userid]);

  useEffect(() => {
    if (
      checkArrayLength(skills) &&
      !skills.find((res) => res.skillName === selectedSkillName)
    ) {
      setSelectedSkillName(first(skills).skillName);
    }
    const top5Skill = orderBy(generateUserSkills(skills || []), "count");
    setTaggedSkillToTarget(top5Skill);
    if (checkArrayLength(top5Skill)) {
      const count =
        top5Skill.length % 5 > 0
          ? [...Array(5 - (top5Skill.length % 5)).keys()]
          : [];
      setNoDataSkill(count);
    }
  }, [skills]);

  return checkArrayLength(taggedSkillToTarget) ? (
    <Box mt={3}>
      <Typography
        variant="subtitle"
        className="font-semibold font-16 score-chart-label"
      >
        {label}
      </Typography>
      <SkillScoreChart
        totalRaters={totalRaters}
        skillsCount={checkArrayLength(taggedSkillToTarget)}
        skills={orderBy(taggedSkillToTarget, "count", "desc")}
        nodataSkill={nodataSkill}
        selectedSkillName={selectedSkillName}
        setSelectedSkillName={setSelectedSkillName}
      />
    </Box>
  ) : null;
};

export default ScoreChart;
